import type { ComponentProps, ReactNode } from 'react';
import { cn } from '@/lib/cn';

export const Card = ({ className, ...props }: ComponentProps<'section'>) => (
  <section
    className={cn('rounded-lg border border-border-default bg-bg-raised', className)}
    {...props}
  />
);

export const CardHeader = ({
  title,
  description,
  actions,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) => (
  <header
    className={cn(
      'flex items-start justify-between gap-4 border-b border-border-default px-4 py-3',
      className,
    )}
  >
    <div className="min-w-0">
      <h2 className="text-sm font-semibold text-fg">{title}</h2>
      {description ? <p className="mt-0.5 text-xs text-fg-muted">{description}</p> : null}
    </div>
    {actions ? <div className="shrink-0">{actions}</div> : null}
  </header>
);

export const CardBody = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={cn('p-4', className)} {...props} />
);

/**
 * What a card shows when it has nothing to show.
 *
 * A named component rather than an inline ternary per screen, because "empty"
 * is a state every list has, distinct from loading or broken.
 */
export const EmptyState = ({ children }: { children: ReactNode }) => (
  <p className="px-4 py-6 text-center text-sm text-fg-muted">{children}</p>
);
